"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectWebpSupport = exports.selectUser = exports.selectUrls = exports.selectTokenParams = exports.selectToken = exports.selectTheme = exports.getWebpSupport = exports.getUser = exports.getUrls = exports.getTokenParams = exports.getToken = exports.getTheme = void 0;
var _constants = require("../../../utils/constants");
var _Types = require("../../../Types");
/** @deprecated getToken use selectToken */
const getToken = _ref => {
  let {
    [_constants.packageKey]: {
      user
    } = {}
  } = _ref;
  return (user === null || user === void 0 ? void 0 : user.token) || null;
};
/** @deprecated getTokenParams use selectTokenParams */
exports.getToken = getToken;
const getTokenParams = _ref2 => {
  let {
    [_constants.packageKey]: {
      user
    } = {}
  } = _ref2;
  return (user === null || user === void 0 ? void 0 : user.tokenParams) || {};
};
/** @deprecated getTheme use selectTheme */
exports.getTokenParams = getTokenParams;
const getTheme = _ref3 => {
  let {
    [_constants.packageKey]: {
      user
    } = {}
  } = _ref3;
  return (user === null || user === void 0 ? void 0 : user.theme) || null;
};

/** @deprecated getUser use selectUser */
exports.getTheme = getTheme;
const getUser = _ref4 => {
  let {
    [_constants.packageKey]: {
      user
    } = {}
  } = _ref4;
  return user || {};
};
/** @deprecated getWebpSupport use selectWebpSupport */
exports.getUser = getUser;
const getWebpSupport = _ref5 => {
  let {
    [_constants.packageKey]: {
      user
    } = {}
  } = _ref5;
  return user.webpSupport || null;
};
/** @deprecated getUrls use selectUrls */
exports.getWebpSupport = getWebpSupport;
const getUrls = _ref6 => {
  let {
    [_constants.packageKey]: {
      user
    } = {}
  } = _ref6;
  return (user === null || user === void 0 ? void 0 : user.urls) || _Types.urlsTypesDefault;
};
exports.getUrls = getUrls;
const selectToken = _ref7 => {
  let {
    [_constants.packageKey]: {
      user
    } = {}
  } = _ref7;
  return (user === null || user === void 0 ? void 0 : user.token) || null;
};
exports.selectToken = selectToken;
const selectTokenParams = _ref8 => {
  let {
    [_constants.packageKey]: {
      user
    } = {}
  } = _ref8;
  return (user === null || user === void 0 ? void 0 : user.tokenParams) || {};
};
exports.selectTokenParams = selectTokenParams;
const selectTheme = _ref9 => {
  let {
    [_constants.packageKey]: {
      user
    } = {}
  } = _ref9;
  return (user === null || user === void 0 ? void 0 : user.theme) || null;
};
exports.selectTheme = selectTheme;
const selectUser = _ref10 => {
  let {
    [_constants.packageKey]: {
      user
    } = {}
  } = _ref10;
  return user || {};
};
exports.selectUser = selectUser;
const selectWebpSupport = _ref11 => {
  let {
    [_constants.packageKey]: {
      user
    } = {}
  } = _ref11;
  return user.webpSupport || null;
};
exports.selectWebpSupport = selectWebpSupport;
const selectUrls = _ref12 => {
  let {
    [_constants.packageKey]: {
      user
    } = {}
  } = _ref12;
  return (user === null || user === void 0 ? void 0 : user.urls) || _Types.urlsTypesDefault;
};
exports.selectUrls = selectUrls;